<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Confirm</h5>
    <button
      type="button"
      class="close"
      (click)="onCancelClick()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form
    class="my-4 p-4"
    (ngSubmit)="onSubmit()"
    style="max-width: 400px; margin: auto">
    <!-- <div class="form-group d-flex align-items-center">
        <label for="language" class="mr-2">Download in:</label>
        <select
          id="language"
          name="language"
          class="form-control"
          [(ngModel)]="formData.language"
          style="width: 100px">
          <option *ngFor="let language of languages" [value]="language.value">
            {{ language.label }}
          </option>
        </select>
      </div> -->
    <div *ngIf="data.module === 'SALES' || data.module === 'FLIGHT'">
      <div class="form-check mb-3 d-flex align-items-center label-justify">
        <label class="" for="isDeadHead">Include Dead Head</label>
        <input
          type="checkbox"
          class="form-check-input"
          id="isDeadHead"
          name="isDeadHead"
          [(ngModel)]="formData.deadHead" />
      </div>

      <div class="form-check mb-3 d-flex align-items-center label-justify">
        <label class="" for="isChecked">Include Flight Time</label>
        <input
          type="checkbox"
          class="form-check-input"
          id="isChecked"
          name="isChecked"
          [(ngModel)]="formData.flightTime" />
      </div>

      <div class="form-check mb-3 d-flex align-items-center label-justify">
        <label class="" for="layoverTime">Include Layover Time</label>
        <input
          type="checkbox"
          class="form-check-input"
          id="layoverTime"
          name="layoverTime"
          [(ngModel)]="formData.layoverTime" />
      </div>
    </div>

    <div *ngIf="data.module === 'FINANCE'">
      <label for="currency-radio-group">Currency:</label>
      <br />
      <mat-radio-group
        id="currency-radio-group"
        [(ngModel)]="selectedCurrency.showUsd"
        name="currency">
        <mat-radio-button color="primary" [value]="false">SAR</mat-radio-button>
        <mat-radio-button color="primary" [value]="true"
          >SAR and USD</mat-radio-button
        >
      </mat-radio-group>
    </div>

    <button type="submit" class="btn btn-primary mt-3">Submit</button>
  </form>

  <!-- Additional modal sections (e.g., footer) if needed -->
</div>
